import type { TextContentData } from '@/components/canvas/document/publicTypes';
import type { TextBlockKind } from '@/components/canvas/elements/text/utils/textContent';
import {
  applyTextEditorBold,
  applyTextEditorColor,
} from '@/components/canvas/elements/text/editor/textEditorSession';

export const textEditingState: {
  editor: unknown | null;
  selectionState: unknown | null;
  baseTextRef: TextContentData | null;
  pendingClickX: number | null;
  pendingClickY: number | null;
  pendingSelectAll: boolean;
  enterOptions?: { selectAll?: boolean; clickX?: number; clickY?: number };
} = {
  editor: null,
  selectionState: null,
  baseTextRef: null,
  pendingClickX: null,
  pendingClickY: null,
  pendingSelectAll: false,
};

export function applyColorToSelection(color: string): boolean {
  return applyTextEditorColor(color);
}

export function applyBoldToSelection(): boolean {
  return applyTextEditorBold();
}

export function applyFontSizeToSelection(): boolean {
  return false;
}

export function setTextSelectionBlockType(_blockKind: TextBlockKind): null { return null; }
